/**
 * Spacing function — each argument is multiplied by 4px.
 * spacing(1)       → '4px'
 * spacing(2)       → '8px'
 * spacing(1, 2)    → '4px 8px'
 * spacing(2, 4, 2) → '8px 16px 8px'
 */
export const spacing = (...args) =>
  args.map((m) => `${m * 4}px`).join(' ');
